import type { ProductionDocument } from '@/types'
import type { ApplicationFormValues } from '@/features/admin/types'
import type { EventFormValues } from '@/features/ticketing/types'

type LinkedProduction = ProductionDocument & { id: string }

export function linkedEventDefaults(
  production: LinkedProduction,
): Pick<EventFormValues, 'title' | 'slug' | 'venue' | 'eventDate' | 'productionId'> {
  return {
    title: production.name,
    slug: production.slug,
    venue: production.venue,
    eventDate: production.startDate,
    productionId: production.id,
  }
}

export function linkedIntakeApplicationDefaults(
  production: LinkedProduction,
): Pick<
  ApplicationFormValues,
  'title' | 'slug' | 'applicationType' | 'productionId' | 'status' | 'isPublished'
> {
  return {
    title: `${production.name} Application`,
    slug: `${production.slug}-application`,
    applicationType: 'production_intake',
    productionId: production.id,
    status: 'draft',
    isPublished: false,
  }
}
